import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

function About() {
  return (
    <div className="about-page-wrapper">
      {/* Skyscraper Hero Banner Section */}
      <div className="about-hero">
        <div className="about-hero-overlay"></div>
        <div className="about-hero-content">
          <h2>About Us</h2>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="about-content-section">
        <div className="about-breadcrumb-container">
          <Link to="/" onClick={() => window.scrollTo(0,0)} className="breadcrumb-home" style={{ textDecoration: 'none' }}>Home</Link>
          <span className="breadcrumb-separator"> / </span>
          <span className="breadcrumb-current">About us</span>
        </div>

        <div className="about-main-grid">
          <div className="about-left-phone-section">
            <div className="about-circle-backdrop">
              <img src="/Image/aboutus-left-cont.png" alt="ZustGo Mobile App Screens" className="about-combined-phones" />
            </div>
          </div>

          <div className="about-right-text-section">
            <h1 className="about-headline">About <span className="green-accent">ZustGo</span></h1>
            <div className="about-description-paragraphs">
              <p>ZustGo is an online food ordering and delivery platform designed to bring your favorite meals right to your doorstep across Tamil Nadu, India.</p>
              <p>ZustGo connects you with a wide range of popular restaurants and local vendors in both Tier II and Tier III cities. With just a few taps, you can explore nearby restaurants, browse menus, and order your favorite food or daily essentials from the comfort of your home.</p>
              <p>The ZustGo app makes ordering easy and convenient. You can select your preferred restaurant, choose your favorite dishes, and place your order with flexible payment options like online payment or cash on delivery. Your order will be delivered quickly and safely to your location.</p>
              <p>At ZustGo, our mission is to simplify everyday living by making food and essentials easily accessible, while also helping local businesses grow and serve their customers more efficiently.</p>
              <p>ZustGo is available on both Android and iOS platforms.<br />Download ZustGo today and enjoy fast, easy, and reliable delivery at your fingertips.</p>
            </div>
          </div>
        </div>

        {/* Cities We Deliver To Section */}
        <div className="about-delivery-cities-section">
          <div className="about-delivery-grid">
            <div className="about-delivery-left">
              <div className="about-delivery-left-content">
                <h2 className="about-delivery-title-new">Cities We Deliver To</h2>
                <img src="/Image/about-delivery-map.png" alt="Cities We Deliver To Map Pointer" className="about-delivery-map-img" />
              </div>
            </div>
            <div className="about-delivery-right">
              <img src="/Image/about-delivery-driver.png" alt="ZustGo Delivery Driver" className="about-delivery-driver-img" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;